import {SearchableItemService} from "../../../services/SearchableItemService";
import {textFilterParamsValues} from "../reactTableController";
import { booleanFilterParams, getBooleanValueGetter } from "../../utils/booleanColUtils";
export const defaultSortModel = [
    {
        colId: 'f13DateTime',
        sort: 'desc',
        sortIndex: 0
    },
    {
        colId: "accountNumber",
        sort: "asc",
        sortIndex: 1
    }
];
export const reactIntradaysCols = function ( translate, userService) {
    const filterFormatter = userService.filterFormatter;
    return [ {
        field: "shortName",
        headerName: translate.instant('ACCOUNT_NAME'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "accountNumber",
        headerName: translate.instant('ACCOUNT_NUMBER'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "f13DateTime",
        headerName: translate.instant('DATE_TIME'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.f13DateTime) : "";
        }
    }, {
        field: "statementNoOrig",
        headerName: translate.instant('STATEMENT_NUMB_ORIGINAL'),
        sortable: true,
        filter: 'agNumberColumnFilter'
    }, {
        field: "debitSum",
        headerName: translate.instant('DEBIT_SUM'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debitSum, 2) : "";
        },
        type: 'numericColumn'
    }, {
        field: "debitCount",
        headerName: translate.instant('DEBIT_COUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debitCount) : "";
        },
        type: 'numericColumn'
    }, {
        field: "creditSum",
        headerName: translate.instant('CREDIT_SUM'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.creditSum, 2) : "";
        },
        type: 'numericColumn'
    },  {
        field: "creditCount",
        headerName: translate.instant('CREDIT_COUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.creditCount) : "";
        },
        type: 'numericColumn'
    }, {
        field: "f86Bank",
        headerName: translate.instant('INF_TO_ACCOWN'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "bank",
        headerName: translate.instant('BANK'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bank'])
                    .then(data => params.success(data.map(it => it.name)));
            }},
        initialHide: true
    }, {
        field: "bic",
        headerName: translate.instant('BIC'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['bic'])
                    .then(data => params.success(data.map(it => it.code)));
            }},
        initialHide: true
    },{
        field: "country",
        headerName: translate.instant('COUNTRY'),
        sortable: true,
        filter:  "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['country'])
                    .then(data => params.success(data.map(it => it.name)));
            }},
        initialHide: true
    },{
        field: "currency",
        headerName: translate.instant('CURRENCY'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { values: params => {// fetch values from server
                new SearchableItemService(userService).readKindItems(['currency'])
                    .then(data => params.success(data.map(it => it.code)));
            }},
        initialHide: true
    },{
        field: "transactionRefNo",
        headerName: translate.instant('TRANS_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues,
        initialHide: true
    },{
        field: "relatedReference",
        headerName: translate.instant('RELATED_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues,
        initialHide: true
    }, {
        field: "debitFloor",
        headerName: translate.instant('DEBIT_FLOOR_LIMIT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debitFloor, 2) : "";
        },
        type: 'numericColumn'
    }, {
        field: "creditFloor",
        headerName: translate.instant('CREDIT_FLOOR_LIMIT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.creditFloor, 2) : "";
        },
        type: 'numericColumn'
    }, {
        field: "loadTime",
        headerName: translate.instant('RECEIVED_DATETIME'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateTimeNoLocal')( params.data.loadTime) : "";
        },
        initialHide: true
    }, {
        field: "camt052",
        headerName: translate.instant('CAMT052'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: booleanFilterParams('camt052', translate),
        valueGetter: getBooleanValueGetter('camt052', translate, data => data?.account?.camt052),
        initialHide: true
    },];
}
